/* eslint-disable import/prefer-default-export */
import { SET_USE_SYSTEM_TEXT_SIZE, LS_USE_SYSTEM_TEXT_SIZE } from 'constants/index';

export function setTextSizeUseSystem(payload) {
  localStorage.setItem(LS_USE_SYSTEM_TEXT_SIZE, payload);
  return dispatch => {
    dispatch({ type: SET_USE_SYSTEM_TEXT_SIZE, payload });
  };
}
